import { APP_ENVIRONMENT } from '@config/env';
import * as Sentry from '@sentry/react';

Sentry.init({
  enabled: import.meta.env.PROD,
  environment: APP_ENVIRONMENT,
  dsn: 'https://c8f6e7456ea3892f719728a26e840257@sentry.lynxsolutions.eu/16',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.25, //  Capture 25% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/.*\.conversed\.(ai|biz).*/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
